import { render, staticRenderFns } from "./MapBandsForm.vue?vue&type=template&id=793495c8"
import script from "./MapBandsForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapBandsForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports